export default __webpack_public_path__ + "static/media/game-back-icon.889ae0c4.svg";